import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import {
  FaCheck,
  FaCoins,
  FaDiscord,
  FaMedium,
  FaRankingStar,
  FaSquareXTwitter,
} from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import TwitterLogin from "react-twitter-login";

import { BASE_URL, CDN_BASE_URL } from "../../config";
import { getUser } from "../../api/getUser";
import Loading from "../common/Loading";
import MediumModal from "../common/modals/MediumModal";
import TwitterModal from "../common/modals/TwitterModal";
import { httpReauest } from "../../utils/httpRequest";

const UserRanking = ({ data }) => {
  const [users, setusers] = useState();
  const [loading, setloading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, [navigate]);

  async function getData(params) {
    const user = JSON.parse(localStorage.getItem("user"));

    const res = await httpReauest(
      "GET",
      "/user/ranking?sort=-balance&limit=100",
      {},
      { "x-access-token": user?.token }
    );
    setusers(res.data?.data);
    setloading(false);
  }

  const formatDate = (date) => {
    if (!(date instanceof Date) || isNaN(date)) {
      throw new Error("Invalid date provided");
    }

    const day = date.getDate();
    const month = date
      .toLocaleString("default", { month: "short" })
      .toUpperCase();
    const year = date.getFullYear();

    return `${day} ${month}, ${year}`;
  };

  const lastChar = data?._id.slice(-1); // آخرین کاراکتر
  const lastCharAsNumber = parseInt(lastChar, 16); // تبدیل به عدد (0 تا 15)
  const imageNumber = (lastCharAsNumber % 9) + 1; // عدد بین 1 تا 9

  return (
    <>
      <div className="rounded-[66px] bg-[#0E171D] p-3 lg:p-5 gap-5 flex lg:flex-row w-full justify-between items-center relative">
        {" "}
        <span className="flex w-full lg:w-fit justify-start gap-2 lg:gap-4 items-center">
          {data && (
            <img
              src={`/profile/${data?.gender?.toLowerCase()}/${
                data?.level > 6 ? 6 : data?.level
              }.jpg`}
              className="w-24 lg:w-32"
              alt="User Profile"
            />
          )}

          <span>
            <h2 className="font-bold text-[24px] lg:text-[32px]">You</h2>
            <p className=" text-[14px] lg:text-[18px]">
              Joined:{" "}
              {data ? new Date(data?.createdAt).toLocaleDateString() : null}
            </p>
          </span>
        </span>
        <span>
          <h4 className="text-[24px] lg:text-[35px] text-center font-bold pe-2 lg:pe-6">
            #{users?.userRank}
          </h4>
        </span>
      </div>

      <div className="rounded-[66px] bg-[#4A5A69] p-2 lg:px-4 py-5 lg:py-6 gap-5 w-full  relative mt-5">
        <h2 className="text-center font-bold text-[24px] lg:text-[32px] mb-2 lg:mb-6 relative">
          TOP 100{" "}
          <FaRankingStar className="absolute left-4 top-1/2 -translate-y-1/2 text-[#ecebeb] text-[34px] lg:text-[54px]" />
        </h2>
        <h2 className="text-center text-[20px] lg:text-[22px] lg:absolute right-6 top-8 mb-5 lg:mb-0">
          Total Participants : {users?.allUsersCount}
        </h2>

        <div className="flex flex-col gap-3 lg:gap-4 lg:max-h-[50vh] lg:overflow-y-scroll lg:px-4">
          {users?.topUsers?.map((item, index) => {
            // گرفتن آخرین کاراکتر _id و تبدیل آن به عدد (مبنای 16)
            const lastChar = item._id.slice(-1); // آخرین کاراکتر
            const lastCharAsNumber = parseInt(lastChar, 16); // تبدیل به عدد (0 تا 15)
            const imageNumber = (lastCharAsNumber % 9) + 1; // عدد بین 1 تا 9

            return (
              <div
                key={item._id}
                className="flex w-ful justify-between items-center gap-3 bg-[#0E171D] p-3 rounded-[40px]"
              >
                <span className="flex w-full lg:w-fit justfy-start gap-2 lg:gap-4 items-center">
                  <img
                    src={`/profile/${item?.gender?.toLowerCase()}/${
                      item?.level > 6 ? 6 : item?.level
                    }.jpg`}
                    className="w-16 lg:w-28"
                    alt="User Profile"
                  />
                  <span>
                    <h2 className="font-bold text-[22px] lg:text-[32px]">
                      {item?.name}
                    </h2>
                    <p className=" text-[12px] lg:text-[18px]">
                      Joined:{" "}
                      {item
                        ? new Date(item?.createdAt).toLocaleDateString()
                        : null}
                    </p>
                  </span>
                </span>
                <span>
                  <h4 className="text-[14px] lg:text-[30px] text-center font-bold pe-2 lg:pe-6">
                    {item?.balance} FileTrust
                  </h4>
                  <h4 className="text-[24px] lg:text-[35px] text-center font-bold pe-2 lg:pe-6">
                    #{index + 1}
                  </h4>
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default UserRanking;
